import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class AcertoMensalidadeService extends Service {
  async consultarTodosOsProtocolos () {
    let nomes = await this.getAcertoMensalidadeApi().consultarTodosOsProtocolos();
    return nomes || [];
  }

  async consultarOrigens () {
    let origens = await this.getAcertoMensalidadeApi().consultarOrigens();
    return origens || [];
  }

  async consultarEstados () {
    let estados = await this.getAcertoMensalidadeApi().consultarEstados();
    return estados || [];
  }

  async consultarAcertos (numProtocolo, numMatricula, codOrigem, codEstado, numProcesso, anoProcesso, dataInicial, dataFinal) {
    let acertos = [];
    let brancoAcoes = '';
    let tipoBotaoCancelamento = '';
    let botaoAnalisar = '';
    let result = await this.getAcertoMensalidadeApi().consultarAcertos(numProtocolo, numMatricula, codOrigem, codEstado, numProcesso, anoProcesso, dataInicial, dataFinal);
    result.map(res => {
      const { numProtocolo, seqBeneficiario, seqDependente, numMatricula, nomeBeneficiario, valAcerto, codOrigem, desOrigem, codEstado, desEstado, txtObservacao, dtaCadastro, dtaEfeitoFinanc, numProcesso, anoProcesso, valPago, valCorreto, indCancelado, historicos, desSituacao } = res;
      const numAnoProc = numProcesso + '/' + anoProcesso;
      brancoAcoes = indCancelado;
      if (codEstado === 4) {
        tipoBotaoCancelamento = 'DESFAZER';
      } else {
        if (codEstado === 1 || codEstado === 2) {
          tipoBotaoCancelamento = 'CANCELAR';
        } else {
          tipoBotaoCancelamento = 'NENHUM';
        }
      }
      if (codEstado === 1) {
        botaoAnalisar = 'ANALISAR';
      } else {
        botaoAnalisar = 'NENHUM';
      }
      acertos.push(Object.values({ numProtocolo, seqBeneficiario, seqDependente, numMatricula, nomeBeneficiario, valAcerto, codOrigem, desOrigem, codEstado, desEstado, txtObservacao, dtaCadastro, dtaEfeitoFinanc, numAnoProc, valPago, valCorreto, indCancelado, historicos, anoProcesso, numProcesso, tipoBotaoCancelamento, botaoAnalisar, brancoAcoes, desSituacao }));
    });
    return acertos || [];
  }
  async incluirAcerto (acerto) {
    let result = await this.getAcertoMensalidadeApi().incluirAcerto(acerto);
    return result;
  }
  async alterarAcerto (acerto) {
    let result = await this.getAcertoMensalidadeApi().alterarAcerto(acerto);
    return result;
  }
  async excluirAcertosEmLote (acertos) {
    const result = await this.getAcertoMensalidadeApi().excluirAcertosEmLote(acertos);
    return result;
  }
  async processarAcerto (numProtocolo) {
    const result = await this.getAcertoMensalidadeApi().processarAcerto(numProtocolo);
    return result;
  }
  async cancelarAcerto (numProtocolo, motivoCancelamento) {
    const result = await this.getAcertoMensalidadeApi().cancelarAcerto(numProtocolo, motivoCancelamento);
    return result;
  }
  async desfazerCancelamentoAcerto (numProtocolo) {
    const result = await this.getAcertoMensalidadeApi().desfazerCancelamentoAcerto(numProtocolo);
    return result;
  }
  async analisarAcerto (numProtocolo) {
    let result = await this.getAcertoMensalidadeApi().analisarAcerto(numProtocolo);
    return result;
  }
  async excluirAcerto (numProtocolo) {
    let result = await this.getAcertoMensalidadeApi().excluirAcerto(numProtocolo);
    return result;
  }
}
export default AcertoMensalidadeService;
